import styled from "styled-components";
import { theme } from "uikit";

const Root = styled.div<{ bgColor?: string }>`
	display: flex;
	justify-content: center;
	align-items: center;

	min-width: 32px;
	min-height: 32px;

	max-width: 32px;
	max-height: 32px;

	font-family: Inter;
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
	letter-spacing: 0em;
	text-align: center;

	color: ${theme.colors.white};
	background-color: ${({ bgColor }) => bgColor || theme.colors.disabled_text};

	border-radius: 50%;
`;

export default Root;
